import Handlebars from 'handlebars';
      const _template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-test-label-proactive class='ml-4'>\n  <div class='text-lg' style='color: "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + ";'>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"proactives") : depth0), depth0))
    + "</div>\n  <div class='font-bold'>Proactive support</div>\n  <div class='font-normal'>messages</div>\n</div>";
},"useData":true});
      export default _template;